module.exports = __webpack_public_path__ + "img/2.f61275c1.jpg";